const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

// Pages sync to the global month picker (Layout.jsx, id="globalMonth") via a 'monthChange' window event.
// Layout persists across route changes, so on navigation the dropdown may already show a month the
// new page's own state doesn't know about yet — read the dropdown's current value first so pages open
// already in sync with it, instead of always defaulting to "today" and waiting for the next change event.
export function getInitialMonth() {
  const el = typeof document !== 'undefined' ? document.getElementById('globalMonth') : null;
  return el?.value || new Date().toISOString().slice(0, 7);
}

export function fmtDate(d) {
  if (!d) return '—';
  const s = typeof d === 'string' ? d.slice(0,10) : d.toISOString().slice(0,10);
  const [y, m, day] = s.split('-');
  if (!y || !m || !day) return d;
  return `${parseInt(day)}-${MONTHS[parseInt(m)-1]}-${y}`;
}

export function buildClientAddress(client) {
  if (!client) return '';
  const parts = [
    client.address_line1,
    client.address_line2,
    [client.city, client.pincode].filter(Boolean).join(' - '),
    client.state,
    client.country !== 'India' ? client.country : '',
  ].filter(Boolean);
  return parts.join('\n');
}
